// Override da BASE_URL da API para porta 5555
import API_CONFIG from './apiConfig';

try {
  // Se estivermos em HTTPS (produção Cloudflare), não forçamos a URL HTTP direta
  // para evitar erro de Mixed Content no navegador.
  // Em vez disso, deixamos a BASE_URL vazia para que as chamadas sejam relativas ao próprio domínio,
  // permitindo que o Cloudflare Functions (na pasta /functions) atue como Proxy.
  const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
  
  if (isHttps) {
    // IMPORTANTE: Definimos BASE_URL como origin para que as chamadas sejam para o mesmo domínio
    // O Cloudflare Functions (pasta /functions/api) interceptará todas as chamadas que começam com /api
    API_CONFIG.BASE_URL = window.location.origin; 
    console.log(`🔧 API em modo Proxy Cloudflare (HTTPS). Base: ${API_CONFIG.BASE_URL}`);
  } else {
    const envBase = process.env.REACT_APP_API_BASE_URL;
    const newBase = envBase || 'http://srv-mupa.ddns.net:5555';
    API_CONFIG.BASE_URL = newBase;
    console.log(`🔧 API BASE_URL override ativo: ${API_CONFIG.BASE_URL}`);
  }
} catch (err) {
  console.warn('Falha ao aplicar override de API BASE_URL', err);
}

// Este módulo tem efeito colateral (não exporta nada) e deve ser importado cedo